(() => {
  const init = () => document.querySelectorAll('[data-js6-similar]').forEach(root => {
    if (root.dataset.similarReady) return;
    root.dataset.similarReady = 'true';
    const track = root.querySelector('[data-js6-similar-track]');
    const previous = root.querySelector('[data-js6-similar-prev]');
    const next = root.querySelector('[data-js6-similar-next]');
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const move = direction => track.scrollBy({left: direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
    // Read the native category-filtered catalog so future imports are included.
    fetch(root.dataset.sourceUrl, {credentials:'same-origin', headers:{Accept:'text/html'}})
      .then(response => { if (!response.ok) throw new Error('Catalog unavailable'); return response.text(); })
      .then(html => {
        if (!root.isConnected) return;
        const page = new DOMParser().parseFromString(html, 'text/html');
        const currentPath = new URL(root.dataset.currentProduct, location.origin).pathname;
        const cards = [...page.querySelectorAll('.js6v2-catalog__results .js6v2-card')].filter(card => {
          const link = card.querySelector('h3 a');
          if (!link || new URL(link.getAttribute('href'), location.origin).pathname === currentPath) return false;
          return Boolean(root.dataset.category) || card.dataset.productType === root.dataset.currentType;
        }).slice(0,8);
        if (!cards.length) return;
        const slides = cards.map(card => { const slide = document.createElement('div'); slide.className = 'js6-similar__slide'; slide.append(card); return slide; });
        track.replaceChildren(...slides);
        root.hidden = false;
        update();
      })
      .catch(() => { /* Keep the server-rendered category matches if loading fails. */ });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

